'use client'

import { type BuilderBlock } from '@builder.io/react/dist/types/src/components/builder-block.component'
import React, { type ReactElement, type ReactNode } from 'react'

import { cn } from '@src/utils/tailwind'

interface Column {
  image: string
  testimonialBlocks: any[] | ReactNode
  programBlocks: any[] | ReactNode
  testimonialCircleBlocks: any[] | ReactNode
}

interface TileProps {
  title: string
  subtitle: string
  variant: 'program' | 'testimonial' | 'testimonialCircle' | 'default'
  imageUrl: string
  children: ReactElement<any>[]
  builderBlock: BuilderBlock
  columns: Column[]
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const Tile = ({ title, imageUrl, children, variant, columns, ...props }: TileProps) => {
  return (
    <div
      className={cn({
        'flex flex-row items-center gap-10 py-2': true,
        '[&_.tile-image]:h-[290px] [&_.tile-image]:w-[290px] [&_.tile-image]:rounded-full [&_.tile]:max-w-[290px]':
          variant === 'testimonialCircle',
        '[&_.tile-image]:h-[290px] [&_.tile-image]:w-[290px] [&_.tile-image]:rounded-[14px] [&_.tile]:max-w-[290px]':
          variant === 'testimonial',
        '[&_.tile-image]:h-[230px] [&_.tile-image]:w-[350px]  [&_.tile-image]:rounded-[14px] [&_.tile-image]:object-contain lg:[&_.tile-image]:h-[265px] lg:[&_.tile-image]:w-[400px] [&_.tile]:max-w-[350px] lg:[&_.tile]:max-w-[400px]':
          variant === 'program',
      })}
    >
      {children}
    </div>
  )
}
